import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Typography
} from '@mui/material';
import { PhasesTags } from '../components/admin/Templates/PhasesTags';
import TextFieldComponent from './TextFieldComponent';
import { FormProvider, useForm } from 'react-hook-form';
import { CLEAR, DESCRIPTION, ENTER_INPUT, TAG_TO_PHASE } from './AppConstants';
import { useState } from 'react';

export function FileUploadCard({
  entity,
  onSave,
  VariableForm, //Needs to either be a react-hook-form or a component that accepts an 'updateContent' prop
  additionalContent,
  title,
  commonProps,
  count,
  variableFormProps,
  hideDescription
}) {
  const formMethods = useForm({
    mode: 'all',
    defaultValues: {}
  });
  const [renderKey, setRenderKey] = useState(0);
  const [variableFormContent, setVariableFormContent] = useState(null);
  const [selectedPhases, setSelectedPhases] = useState([]);

  const clearComponent = () => {
    commonProps?.clearAllMessages();
    formMethods.reset({ Description: '' });
    setVariableFormContent(null);
    setSelectedPhases([]);
    setRenderKey((prevKey) => prevKey + 1);
  };

  const saveAttachment = (event) => {
    const formValues = formMethods.getValues();
    const description = formValues[DESCRIPTION];

    onSave(
      { formValues, description, selectedPhases, variableFormContent },
      event,
      clearComponent
    );
  };
  const saveButtonTitle = entity.charAt(0).toUpperCase() + entity.slice(1);

  return (
    <Card style={{ marginBottom: '1em', overflow: 'visible' }}>
      <CardContent>
        {title && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
              mb: 4
            }}
          >
            <Typography variant={'h2'} sx={{ m: 0 }}>
              {title}
            </Typography>
            {count && count > 0 ? (
              <Chip
                variant="badge"
                color="informational"
                label={count}
                size="small"
              />
            ) : (
              <></>
            )}
          </Box>
        )}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: 'minmax(0, 1fr) minmax(0, 1fr)'
            },
            gap: 4,
            alignItems: 'start'
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Box
              sx={(theme) => ({
                marginBottom: theme.fuel6Tokens.JddcSpacingMedium
              })}
            >
              <FormProvider {...formMethods}>
                <VariableForm
                  key={`${entity}-${renderKey}`}
                  updateContent={setVariableFormContent}
                  setStatusErrorMsg={commonProps?.setStatusErrorMsg}
                  clearAllMessages={commonProps?.clearAllMessages}
                  {...variableFormProps}
                />
              </FormProvider>
            </Box>
            {!hideDescription && (
              <Box component="form">
                <TextFieldComponent
                  control={formMethods.control}
                  maxLength="512"
                  placeholder={ENTER_INPUT}
                  name={DESCRIPTION}
                  label={DESCRIPTION}
                />
              </Box>
            )}
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                mt: 3
              }}
            >
              <Box>
                <Button variant="secondary" onClick={clearComponent}>
                  {CLEAR}
                </Button>
              </Box>
              <Box>
                <Button variant="primary" onClick={saveAttachment}>
                  Save {saveButtonTitle}
                </Button>
              </Box>
            </Box>
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant={'body1'} fontWeight={'600'}>
              {TAG_TO_PHASE}
            </Typography>
            <PhasesTags
              namePrefix={entity}
              selectedPhases={selectedPhases}
              setSelectedPhases={setSelectedPhases}
            />
          </Box>
        </Box>
        {additionalContent && <Box sx={{ mt: 3 }}>{additionalContent}</Box>}
      </CardContent>
    </Card>
  );
}
